/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get vouchers constants
export const VOUCHER_REQUEST_GET = 'VOUCHER_REQUEST_GET';
export const VOUCHER_RESPONSE_GET_SUCCESS = 'VOUCHER_RESPONSE_GET_SUCCESS';
export const VOUCHER_RESPONSE_GET_FAIL = 'VOUCHER_RESPONSE_GET_FAIL'

/**
 * Action types for post voucher data.
 *
 * These constants represent different stages of the voucher data adding process
*/
export const VOUCHER_REQUEST_POST = 'VOUCHER_REQUEST_POST';
export const VOUCHER_RESPONSE_POST_FAIL = 'VOUCHER_RESPONSE_POST_FAIL';
export const  ADD_VOUCHER_RESPONSE_SUCCESS = 'ADD_VOUCHER_RESPONSE_SUCCESS';
export const  ADD_VOUCHER_RESET_SUCCESS_MSG_OR_ERROR = 'ADD_VOUCHER_RESET_SUCCESS_MSG_OR_ERROR';


/**
 * Action types for post group data.
 *
 * These constants represent different stages of the group data deleting process
*/
export const VOUCHER_REQUEST_PATCH = 'VOUCHER_REQUEST_PATCH';
export const VOUCHER_RESPONSE_PATCH_FAIL = 'VOUCHER_RESPONSE_PATCH_FAIL';
export const DELETE_VOUCHER_RESPONSE_SUCCESS = 'DELETE_VOUCHER_RESPONSE_SUCCESS'


/**
 * Action types for put Add Modal.
 *
 * These constants represent different stages of the Add Button Modal process
*/
export const VOUCHER_ADD_MODAL_ALERT = 'VOUCHER_ADD_MODAL_ALERT';
export const VOUCHER_ADD_MODAL = 'VOUCHER_ADD_MODAL';
export const VOUCHER_SELECTED = 'VOUCHER_SELECTED';
export const RESET_VOUCHER_DELETE = 'RESET_VOUCHER_DELETE';
export const RESET_VOUCHER_ADD = 'RESET_VOUCHER_ADD';
export const SUCCESSFULLY_DELETED = 'SUCCESSFULLY_DELETED';
export const VOUCHER_GENERATED_SUCCESSFULLY = 'VOUCHER_GENERATED_SUCCESSFULLY';
export const FAILED_TO_GENERATE_VOUCHER = 'FAILED_TO_GENERATE_VOUCHER';
export const FAILED_TO_DELETE = 'FAILED_TO_DELETE';
export const DELETE_ACTION_TRIGGERED = 'DELETE_ACTION_TRIGGERED';
export const VOUCHER_CODE_MODAL = 'VOUCHER_CODE_MODAL';

